import { render, staticRenderFns } from "./PicoForm.vue?vue&type=template&id=bc00b4ec&scoped=true&"
import script from "./PicoForm.vue?vue&type=script&lang=js&"
export * from "./PicoForm.vue?vue&type=script&lang=js&"
import style0 from "./PicoForm.vue?vue&type=style&index=0&id=bc00b4ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc00b4ec",
  null
  
)

export default component.exports